import {Route, Routes, Outlet, Navigate, Link} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
 
 
 
import {KTCard} from '../../../../_metronic/helpers'
import { AccessDeniedWrapper } from './access-denied--list/AccessDeniedWrapper'
import { AlertContext } from '../../../../_metronic/layout/components/alert-context'
import { useContext, useEffect } from 'react'
const csupportBreadcrumbs: Array<PageLink> = [
  {
    title: 'Access Denied',
    path: '/AccessDenied',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
] 
const AccessDeniedPage = () => {
  const { hideAlert } = useContext(AlertContext);
  useEffect(() => {
    hideAlert(false);
  }, []);
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/list'
          element={
            <>
              
              <PageTitle  breadcrumbs={csupportBreadcrumbs} >Access Denied </PageTitle>
              <AccessDeniedWrapper />
            </>
          }
        />
        
        <Route index element={<Navigate to='list' />} />
      </Route>
    </Routes>
  )
}

export default AccessDeniedPage
